import React from 'react'
import {
  List as ListIcon,
  Book,
  Folder
} from 'react-feather'
import { useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import { TabItem } from '../../../components'

const ListNav = ({embed}) => {
  const history = useHistory()
  const currentPath = useLocation().pathname
  const translation = useSelector(state => state.translation.data)
  const language = useSelector(state => state.system.language)
  const [selected, setSelected] = React.useState(
    currentPath === '/event/upcoming' ? translation.EVENT.upcoming[language.name]
    : currentPath === '/event/past' ? translation.EVENT.past[language.name]
    : translation.EVENT.all[language.name]
  )
  const mobilePadding = embed ? 'pt-2 px-3 pb-2' : 'pt-5 px-5 pb-3'

  const handleClick = (newSelected) => {
    setSelected(newSelected)

    let newPath, newSearch
    if(newSelected === translation.EVENT.upcoming[language.name]){
      newPath = '/event/upcoming'
      newSearch = '?progress=upcoming'
    }
    else if(newSelected === translation.EVENT.past[language.name]){
      newPath = '/event/past'
      newSearch = '?progress=completed'
    }
    else {
      newPath = '/event'
    }

    if(currentPath !== newPath){
      history.push({
        pathname: newPath,
        search: newSearch
      })
    }
  }

  return (
    <div className="flex border-b mb-5 lg:mb-8">
      <TabItem
        selected={selected}
        onClick={handleClick}
        text={translation.EVENT.all[language.name]}
        icon={<ListIcon style={{width: '20px'}}/>}
        className={`${mobilePadding} lg:pt-0 lg:px-0 lg:pb-4 lg:pr-1`}
        accent={embed ? false : true}
        uppercase={embed ? false : true}
        embed
      />
      <TabItem
        selected={selected}
        onClick={handleClick}
        text={translation.EVENT.upcoming[language.name]}
        icon={<Book style={{width: '20px'}}/>}
        className={`${mobilePadding} lg:pt-0 lg:px-0 lg:pb-4 lg:pr-1 lg:ml-12`}
        accent={embed ? false : true}
        uppercase={embed ? false : true}
        embed
      />
      <TabItem
        selected={selected}
        onClick={handleClick}
        text={translation.EVENT.past[language.name]}
        icon={<Folder style={{width: '20px'}}/>}
        className={`${mobilePadding} lg:pt-0 lg:px-0 lg:pb-4 lg:pr-1 lg:ml-12`}
        accent={embed ? false : true}
        uppercase={embed ? false : true}
        embed
      />
    </div>
  )
}

export { ListNav }
